import { useNetworkService } from '@edikk-edikk/di-container';
import { CityForSelectType, FindCityResponseType } from '#home/types';
import { FIND_CITY_URL } from '#home/constants';

const useLoadOptions = () => {
  const networkService = useNetworkService();

  return (search: string) => new Promise<CityForSelectType[]>((resolve) => {
    networkService.get<FindCityResponseType>(FIND_CITY_URL, {
      params: {
        search,
      },
    }).then((response) => {
      resolve(response.data.cityList);
    });
  });
};

export { useLoadOptions };
